import { useState, useEffect } from "react";
import styled from "styled-components";
import DesktopPageHeader from "../../../../components/DesktopPageHeader";
import PromocionesViewer from "../../../../components/PromocionesViewer";
import { usePromocionesMock } from "../../../../hooks/usePromocionesMock";

export const ComunicacionPage = ({ resto }) => {
    const { promociones, markAsRead } = usePromocionesMock();
    const [restoName, setRestoName] = useState("");
    const [avatar, setAvatar] = useState("");

    useEffect(() => {
        if (resto) {
            setRestoName(resto?.name || "");
            setAvatar(resto?.brand || "");
        }
    }, [resto]);

    return (
        <DesktopContainer>
            <DesktopPageHeader img={avatar} alt={restoName} title={restoName} />
            <PageHeader>
                <h2>Novedades</h2>
                <p>Mantente al día con las últimas novedades, promociones y mensajes para tu almacén.</p>
            </PageHeader>
            <PromocionesViewer promociones={promociones} onMarkAsRead={markAsRead} />
        </DesktopContainer>
    );
};

const DesktopContainer = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
`;

const PageHeader = styled.header`
    display: grid;
    gap: 6px;
    margin: 24px 0 18px;

    h2 {
        margin: 0;
        font-size: 22px;
        font-weight: 700;
        color: #111;
    }

    p {
        margin: 0;
        font-size: 14px;
        line-height: 1.5;
        color: #444;
        max-width: 720px;
    }
`;
